import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  ShoppingCart,
  Package,
} from "lucide-react";

const Sidebar = () => {
  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3 rounded-lg transition ${
      isActive
        ? "bg-purple-600 text-white"
        : "text-gray-600 hover:bg-gray-200"
    }`;

  return (
    <div className="w-64 bg-white shadow-lg min-h-screen p-5">
      <h1 className="text-2xl font-bold text-purple-700 mb-8">
        Admin Panel
      </h1>

      <nav className="space-y-2">
        <NavLink to="/admin" className={linkClass} end>
          <LayoutDashboard size={18} /> Dashboard
        </NavLink>

        <NavLink to="/admin/users" className={linkClass}>
          <Users size={18} /> Users
        </NavLink>

        <NavLink to="/admin/orders" className={linkClass}>
          <ShoppingCart size={18} /> Orders
        </NavLink>

        <NavLink to="/admin/packages" className={linkClass}>
          <Package size={18} /> Packages
        </NavLink>
      </nav>
    </div>
  );
};

export default Sidebar;